import React from 'react';

interface VrProps {
  height?: string;
  width?: string;
  color?: string;
}

const Vr = ({ height = '', width = '', color = '' }: VrProps) => {
  const passedStyles: any = () => {
    let style = {};
    if (height != '') {
      style = { ...style, height: height };
    }
    if (width != '') {
      style = { ...style, width: width };
    }
    if (color != '') {
      style = { ...style, background: color };
    }
    return style;
  };

  return <div className='vr' style={passedStyles()} />;
};

export default Vr;
